import { NavItem, NavItemType } from 'models/nav.model';

const NAV_ITEMS_OFFERS: NavItem = {
  title: 'NAV.OFFERS',
  route: '/angebote',
  subItems: [
    {
      title: 'NAV.ALL_OFFERS',
      route: '/angebote'
    },
    {
      title: 'NAV.NEW_OFFER',
      img: 'plus'
    }
  ]
};

export const NAV_ITEMS_RFP: NavItem = {
  title: 'NAV.RFPS',
  route: '/anfragen',
  subItems: []
};

export const NAV_ITEMS_CORE_DATA_DEALER: NavItem = {
  title: 'NAV.CORE_DATA',
  route: '/stammdaten',
  subItems: [
    {
      title: 'NAV.CUSTOMERS',
      route: '/stammdaten/kunden',
      img: 'customers'
    },
    {
      title: 'NAV.OBJECTS',
      route: '/stammdaten/objekte',
      img: 'objekts'
    },
    {
      title: 'NAV.CONDITIONS',
      route: '/stammdaten/konditionen',
      img: 'conditions'
    },
    {
      title: 'NAV.ARTICLES',
      route: '/stammdaten/fremdartikel',
      img: 'articles'
    },
    {
      title: 'NAV.POSITION_TEMPLATES',
      route: '/stammdaten/positionstextvorlagen',
      img: 'position-templates'
    },
    {
      title: 'NAV.EMAIL_TEMPLATES',
      route: '/stammdaten/emailtextvorlagen',
      img: 'email-templates'
    }
  ]
};

export const NAV_ITEMS_CORE_DATA_MANUFACTURER: NavItem = {
  title: 'NAV.CORE_DATA',
  route: '/stammdaten',
  subItems: [
    {
      title: 'NAV.CUSTOMERS',
      route: '/stammdaten/kunden',
      img: 'customers'
    },
    {
      title: 'NAV.OBJECTS',
      route: '/stammdaten/objekte',
      img: 'objekts'
    },
    {
      title: 'NAV.FREE_ARTICLES',
      route: '/stammdaten/fremdartikel',
      img: 'articles'
    },
    {
      title: 'NAV.POSITION_TEMPLATES',
      route: '/stammdaten/positionstextvorlagen',
      img: 'position-templates'
    },
    {
      title: 'NAV.EMAIL_TEMPLATES',
      route: '/stammdaten/emailtextvorlagen',
      img: 'email-templates'
    }
  ]
};

export const NAV_ITEMS_HELP: NavItem = {
  route: 'hilfe',
  img: 'help',
  subItems: []
};

export const NAV_ITEMS_SETTINGS_DEALER: NavItem = {
  route: '/einstellungen',
  img: 'settings',
  subItems: [
    {
      title: 'NAV.BRANCH',
      route: '/einstellungen/niederlassung',
      img: 'company'
    },
    {
      title: 'NAV.TEAM',
      route: '/einstellungen/team',
      img: 'customers'
    },
    {
      title: 'NAV.BRANCHES',
      route: '/einstellungen/niederlassungen',
      img: 'settings'
    }
  ]
};

export const NAV_ITEMS_SETTINGS_MANUFACTURER: NavItem = {
  route: '/einstellungen/unternehmen',
  img: 'settings',
  subItems: [
    {
      title: 'NAV.BRANCH_MANUFACTURER',
      route: '/einstellungen/unternehmen',
      img: 'company'
    },
    {
      title: 'NAV.TEAM',
      route: '/einstellungen/team',
      img: 'customers'
    }
  ]
};

export const NAV_ITEMS_ACCOUNT: NavItem = {
  route: './mein-profil',
  title: NavItemType.ACCOUNT,
  subItems: [
    {
      title: 'NAV.ACCOUNT',
      route: './mein-profil'
    },
    {
      title: 'NAV.SIGN_OUT',
      img: 'signout'
    }
  ]
};

export const NAV_ITEMS_BRANCH: NavItem = {
  title: NavItemType.BRANCH,
  subItems: []
};

export const HEADER_NAV_MENU_MANUFACTURER: NavItem[] = [
  NAV_ITEMS_OFFERS,
  NAV_ITEMS_RFP,
  NAV_ITEMS_CORE_DATA_MANUFACTURER
];

export const HEADER_NAV_MENU_DEALER: NavItem[] = [
  NAV_ITEMS_OFFERS,
  NAV_ITEMS_CORE_DATA_DEALER
];

export const HEADER_SIDE_NAV_MENU_MANUFACTURER: NavItem[] = [
  // uncomment to add 'help' icon in navigation
  // NAV_ITEMS_HELP,
  NAV_ITEMS_SETTINGS_MANUFACTURER,
  NAV_ITEMS_ACCOUNT
];

export const HEADER_SIDE_NAV_MENU_DEALER: NavItem[] = [
  // uncomment to add 'help' icon in navigation
  // NAV_ITEMS_HELP,
  NAV_ITEMS_SETTINGS_DEALER,
  NAV_ITEMS_BRANCH,
  NAV_ITEMS_ACCOUNT
];
